module.exports = __webpack_public_path__ + "static/media/stock_options.eb7e3e18.svg";